import { SegmentedProgressBar } from './SegmentedProgressBar'

export type PackedItemsFunnelProgressStats = {
  total: number
  unaddressed: number
  inProgress: number
  completed: number
}

type FunnelLegendLabels = {
  unaddressed: { label: string; tooltip: string }
  inProgress: { label: string; tooltip: string }
  completed: { label: string; tooltip: string }
}

type PackedItemsFunnelProgressBarProps = {
  stats: PackedItemsFunnelProgressStats
  labels: FunnelLegendLabels
}

export function PackedItemsFunnelProgressBar({
  stats,
  labels,
}: PackedItemsFunnelProgressBarProps) {
  return (
    <SegmentedProgressBar
      total={stats.total}
      segments={[
        {
          key: 'unaddressed',
          count: stats.unaddressed,
          className: 'bg-destructive',
          label: labels.unaddressed.label,
          tooltip: labels.unaddressed.tooltip,
        },
        {
          key: 'inProgress',
          count: stats.inProgress,
          className: 'bg-amber-500',
          label: labels.inProgress.label,
          tooltip: labels.inProgress.tooltip,
        },
        {
          key: 'completed',
          count: stats.completed,
          className: 'bg-green-600 dark:bg-green-500',
          label: labels.completed.label,
          tooltip: labels.completed.tooltip,
        },
      ]}
    />
  )
}
